import { ActionType } from "../actions/ActionTypes";

interface ImageState {
  loading: boolean;
  image: any;
  images: any[];
  error: string | null;
  generate_loading: boolean;
  editLoading: boolean;
  message: string;
}

const initialState: ImageState = {
  loading: false,
  image: null,
  images: [],
  error: null,
  generate_loading: false,
  editLoading: false,
  message: "",
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    // INIT actions set loading and clear error/message
    case ActionType.GENERATE_IMAGE_INIT:
      return {
        ...state,
        error: null,
        generate_loading: true,
        message: "",
      };

    case ActionType.DELETE_IMAGE_INIT:
    case ActionType.GET_SINGLE_IMAGE_INIT:
    case ActionType.GET_ALL_IMAGE_INIT:
    case ActionType.CANCEL_IMAGE_INIT:
      return {
        ...state,
        loading: true,
        error: null,
        message: "",
      };

    // SUCCESS actions update state with data and clear loading
    case ActionType.GENERATE_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        image: action.payload,
        error: null,
        generate_loading: false,
      };

    case ActionType.DELETE_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        images: state.images.filter(
          (image) => image.imageId !== action.payload.imageId
        ),
        error: null,
      };

    case ActionType.GET_SINGLE_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        image: action.payload,
        error: null,
      };

    case ActionType.GET_ALL_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        images: action.payload,
        error: null,
      };

    // CANCEL success should notify the user via toast
    case ActionType.CANCEL_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
      };

    // EDIT image caption cases
    case ActionType.EDIT_IMAGE_CAPTION_INIT:
      return {
        ...state,
        error: null,
        editLoading: true,
      };

    case ActionType.EDIT_IMAGE_CAPTION_SUCCESS:
      return {
        ...state,
        editLoading: false,
        images: state.images.map((image: any) =>
          image.imageId === action.payload.imageId
            ? {
              ...image,
              caption: action.payload.newCaption,
            }
            : image
        ),
      };

    // FAIL actions set error and clear loading
    case ActionType.GENERATE_IMAGE_FAIL:
    case ActionType.DELETE_IMAGE_FAIL:
    case ActionType.GET_SINGLE_IMAGE_FAIL:
    case ActionType.CANCEL_IMAGE_FAIL:
      return {
        ...state,
        loading: false,
        generate_loading: false,
        error: action.payload,
      };
    case ActionType.GET_ALL_IMAGE_FAIL:
      return {
        ...state,
        loading: false,
        images: [],
        generate_loading: false,
        error: action.payload,
      };
    case ActionType.EDIT_IMAGE_CAPTION_FAIL:
      return {
        ...state,
        error: action.payload,
        editLoading: false,
      };

    default:
      return state;
  }
};

export default reducer;
